export default {
  lightBlue: '#0376DA',
  lightGray: '#5E6D7A',
  grayFont: '#1C2025',
  disabled: '#A4B8D1',
  lightFont: '#FFF',
  darkFont: '#000',
  star: '#F1AD33',
  nunitoFont: `font-family: 'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
  defaultBackground: 'radial-gradient(#2A5F90, #0E4374)',
  defaultBackgroundVpaaS: 'radial-gradient(#0E4374, #1C2025)',
  sansSerif: 'font-family: Arial, Helvetica, sans-serif',
  colorDelimiter: '#F2F2F2',
  borderColor: '#D1DBE8',
  vpaasMarketingBackground: '#D1DBE8',
}